import pathfinder from '@fiverr-private/pathfinder';
import { PATHFINDER } from '../../constants';

export const getStorePath = ({ slug }, source) => {
    const params = { store_name: slug };
    const options = { query: { source } };
    return pathfinder(PATHFINDER.STORE, params, options);
};
